import PageLayoutSectionView from '../../PageSectionLayout.View';

type BrandActionsViewProps = {
  sections: {
    label: React.ReactNode;
    content: React.ReactNode;
  }[];
};

const BrandActionsView = ({ sections }: BrandActionsViewProps) => (
  <PageLayoutSectionView sections={sections} />
);

export default BrandActionsView;
